// extracted by mini-css-extract-plugin
export var fallback = "_b-0";
export var icon = "_b-1";